import { Badge } from "@/components/ui"
import { Card, CardContent } from "@/components/ui/card"
import {  CheckCircle2, Circle } from "lucide-react"
import { useUpdatePartner } from "@/hooks/usePartners"
import { OnboardingTask } from "@/constants/partner"
import TaskCardModal from "./TaskCardModal"


function TaskCard({  toggleTask, task }: {  task: OnboardingTask, toggleTask: ( taskId: string, currentStatus: boolean ) => void }) {
  const updatePartner = useUpdatePartner()
  
  return (
    <Card 
      className={`transition-all ${
        task.completed 
          ? 'bg-green-50 dark:bg-green-950/20 border-green-200 dark:border-green-800' 
          : 'hover:shadow-md'
      }`}
    >
      <CardContent className="p-2 px-4">
        <div className="flex items-start gap-4">
          <button
            onClick={() => toggleTask(task.id, task.completed)}
            className="mt-1 flex-shrink-0"
            disabled={updatePartner.isPending}
          >
            {task.completed ? ( <CheckCircle2 className="size-6 text-green-600 dark:text-green-400" /> ) : ( <Circle className="size-6 text-gray-400 hover:text-blue-600 transition-colors" /> )}
          </button>

            <div className="flex items-center justify-between gap-4 w-full">
              <div className="flex items-center gap-3 ">
                <h3 className={` font-semibold ${task.completed && 'line-through text-muted-foreground' }`}>{task.title}</h3>
                {task.required && ( <Badge variant="destructive" className="text-[8px] ">Required</Badge> )}
              </div>
              <TaskCardModal 
                title={task.title} 
                description={task.description} 
                sections={task.modalSections || []}
                link={task.link} 
              />
            </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default TaskCard